module.exports = __webpack_public_path__ + "img/Kyouka.06c81b6f.png";